import { ButtonSchema } from '@fhnw/schemas/button';
import { MediaSchema } from '@fhnw/schemas/media';
import { messages } from './messages';

export const listingSchemaEnhancer = ({
  schema,
  intl,
  formData,
}: {
  schema: any;
  intl: any;
  formData: any;
}) => {
  schema.fieldsets[0].fields.push('useTable');
  schema.properties.useTable = {
    title: intl.formatMessage(messages.UseTable),
    type: 'boolean',
    default: false,
  };
  if (!formData?.activateFilter) {
    schema.fieldsets[0].fields.push('useCards');
  }
  schema.properties.useCards = {
    title: intl.formatMessage(messages.UseCards),
    type: 'boolean',
    default: true,
  };

  schema.fieldsets[0].fields.push('showTeaserImage');
  schema.properties.showTeaserImage = {
    title: intl.formatMessage(messages.ShowTeaserImage),
    type: 'boolean',
    default: true,
  };

  schema.fieldsets[0].fields.push('showTeaserText');
  schema.properties.showTeaserText = {
    title: intl.formatMessage(messages.ShowTeaserText),
    type: 'boolean',
    default: true,
  };

  schema.fieldsets[0].fields.push('showPrivatePages');
  schema.properties.showPrivatePages = {
    title: intl.formatMessage(messages.ShowPrivatePages),
    type: 'boolean',
    default: true,
  };

  schema.fieldsets[0].fields.push('activateFilter');
  schema.properties.activateFilter = {
    title: intl.formatMessage(messages.ActivateFilter),
    type: 'boolean',
    default: false,
  };

  const teaserMediaHiddenFields = ['format', 'image_title', 'caption'];
  const teaserMediaSchema = MediaSchema({ intl });
  teaserMediaSchema.fieldsets[0].fields =
    teaserMediaSchema.fieldsets[0].fields.filter(
      (field: string) => !teaserMediaHiddenFields.includes(field),
    );

  schema.fieldsets.push({
    id: 'teaser',
    title: intl.formatMessage(messages.TeaserCard),
    fields: formData?.showTeaserCard
      ? [
          'showTeaserCard',
          'teaserCardPosition',
          'teaserCardTitle',
          'teaserCardText',
          'teaserCardMedia',
          'teaserCardActions',
        ]
      : ['showTeaserCard'],
  });

  schema.properties.showTeaserCard = {
    title: intl.formatMessage(messages.ShowTeaserCard),
    type: 'boolean',
    default: false,
  };
  schema.properties.teaserCardPosition = {
    title: intl.formatMessage(messages.TeaserCardPosition),
    description: intl.formatMessage(messages.TeaserCardPositionHelp),
    type: 'number',
    minimum: 1,
    default: 1,
  };
  schema.properties.teaserCardTitle = {
    title: intl.formatMessage(messages.Title),
    widgetOptions: {
      frontendOptions: {
        widget: 'text',
      },
    },
  };
  schema.properties.teaserCardText = {
    title: intl.formatMessage(messages.Text),
    description: intl.formatMessage(messages.TeaserCardTextHelp),
    widgetOptions: {
      frontendOptions: {
        widget: 'textarea',
      },
    },
  };
  schema.properties.teaserCardMedia = {
    title: intl.formatMessage(messages.Media),
    widgetOptions: {
      frontendOptions: {
        widget: 'custom_object_widget',
        widgetProps: {
          schema: teaserMediaSchema,
        },
      },
    },
  };
  schema.properties.teaserCardActions = {
    title: intl.formatMessage(messages.Actions),
    widgetOptions: {
      frontendOptions: {
        widget: 'custom_object_list_widget',
        widgetProps: {
          schema: ButtonSchema({ intl }),
        },
      },
    },
  };

  if (!formData?.activateFilter) return schema;

  schema.fieldsets.push({
    id: 'filters',
    title: 'Filter',
    fields: ['filters', 'allowLayoutSwitch', 'sortSelection'],
  });

  schema.properties.filters = {
    title: intl.formatMessage(messages.Filter),
    widgetOptions: {
      frontendOptions: {
        widget: 'custom_object_list_widget',
        widgetProps: {
          schema: {
            title: intl.formatMessage(messages.Filter),
            addMessage: 'hinzufügen',
            fieldsets: [
              {
                id: 'default',
                title: 'Default',
                fields: ['title', 'index'],
              },
            ],
            properties: {
              title: {
                title: intl.formatMessage(messages.Label),
                widgetOptions: {
                  frontendOptions: {
                    widget: 'text',
                  },
                },
              },
              index: {
                title: intl.formatMessage(messages.Field),
                widgetOptions: {
                  frontendOptions: {
                    widget: 'filter_widget',
                  },
                },
              },
            },
            required: ['index'],
          },
        },
      },
    },
  };

  schema.properties.allowLayoutSwitch = {
    title: intl.formatMessage(messages.AllowLayoutSwitch),
    type: 'boolean',
    default: false,
  };

  schema.properties.sortSelection = {
    title: intl.formatMessage(messages.SortSelection),
    widgetOptions: {
      frontendOptions: {
        widget: 'custom_object_list_widget',
        widgetProps: {
          schema: {
            title: intl.formatMessage(messages.SortOrder),
            addMessage: 'hinzufügen',
            fieldsets: [
              {
                id: 'default',
                title: 'Default',
                fields: ['title', 'index', 'reverse'],
              },
            ],
            properties: {
              title: {
                title: intl.formatMessage(messages.Label),
                widgetOptions: {
                  frontendOptions: {
                    widget: 'text',
                  },
                },
              },
              index: {
                title: intl.formatMessage(messages.Field),
                widgetOptions: {
                  frontendOptions: {
                    widget: 'query_sorting_selection_widget',
                  },
                },
              },
              reverse: {
                title: intl.formatMessage(messages.Descending),
                type: 'boolean',
              },
            },
            required: ['index'],
          },
        },
      },
    },
  };

  return schema;
};
